<app-side-menu>
  <div class="dash-users-content">
    <div class="welcome-hero card shadow-sm border-0">
      <div class="row g-0 align-items-stretch">
        <div class="col-12 col-lg-6">
          <div class="welcome-content p-4 p-md-5">
            <img class="welcome-logo" src="assets/branding/flit-core-logo-light.svg" alt="Flit Core" />

            <h1 class="welcome-title mt-3">
              Otimize sua gestão com um ERP confiável, robusto e intuitivo.
            </h1>

            <p class="text-muted mt-3 mb-0">
              Use o menu lateral para navegar pelos módulos e acessar suas rotinas.
            </p>

            <div class="mt-4">
              <a class="btn btn-primary" routerLink="/profile">
                Ver meu perfil
              </a>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <div class="welcome-media">
            <img
              class="welcome-image"
              src="assets/home.jpg"
              alt="Imagem ilustrativa"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
